var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.620704 14C0.277905 14 0 13.7151 0 13.3636C0 13.0415 0.233562 12.7752 0.536492 12.7331L0.620694 12.7274H7.44826C9.22106 12.7274 10.6685 11.2985 10.7544 9.50282L10.7585 9.33349V9.1214C10.7585 6.72277 8.90937 4.7669 6.59294 4.67057L6.41384 4.66685H2.12943L4.37085 6.97523C4.59077 7.20161 4.6101 7.55517 4.42934 7.80388L4.36918 7.87512C4.14838 8.10069 3.80352 8.12051 3.56084 7.93518L3.49136 7.87341L0.180952 4.46652C-0.0389681 4.24014 -0.058301 3.88657 0.122463 3.63786L0.18262 3.56663L3.49302 0.185495C3.73591 -0.0625172 4.12885 -0.0617132 4.37083 0.187205C4.59075 0.413588 4.61009 0.767152 4.42932 1.01597L4.36916 1.0872L2.11293 3.39387H6.41392C9.4334 3.39387 11.8934 5.85004 11.9967 8.92006L12 9.12118V9.33328C12 11.8477 10.0604 13.8977 7.63143 13.9961L7.44841 13.9998L0.620704 14Z",
    fill: "#43927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.81d58dcf5f3a8bd8999af9fb01a223a7.svg";
export { ForwardRef as ReactComponent };